import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IncomeAndAssetsSteps } from '../../../../enums/income-and-assets-steps.enum';
import { IncomeSourceComponent } from './steps/income-source/income-source.component';
import { InvestmentExtraIncomeComponent } from './steps/investment-extra-income/investment-extra-income.component';
import { InvestmentRentalIncomeComponent } from './steps/investment-rental-income/investment-rental-income.component';
import { OtherBankStatementsComponent } from './steps/other-bank-statements/other-bank-statements.component';
import { OtherIncomeSourceComponent } from './steps/other-income-source/other-income-source.component';
import { OtherSupportIncomeComponent } from './steps/other-support-income/other-support-income.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { StepperProgressBarService } from '../../../../services/stepper-progress-bar.service';

@Component({
  selector: 'lgv-income-and-assets-section',
  standalone: true,
  imports: [CommonModule,
    IncomeSourceComponent, InvestmentExtraIncomeComponent,
    InvestmentRentalIncomeComponent, OtherBankStatementsComponent,
    OtherIncomeSourceComponent, OtherSupportIncomeComponent,
    MatProgressBarModule
  ],
  templateUrl: './income-and-assets-section.component.html',
  styleUrls: ['./income-and-assets-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IncomeAndAssetsSectionComponent {

  @Input() specificStep = '';
  @Output() sectionChange = new EventEmitter<any>();

  sectionTitle = 'Income and Assets'
  IncomeAndAssetsSteps = IncomeAndAssetsSteps
  public currentStep: any = IncomeAndAssetsSteps.IncomeSource

  get progress(): number {
    return this.progressService.calculateProgress(this.currentStep);
  }

  constructor(
    public progressService: StepperProgressBarService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['specificStep']) {
      this.currentStep = this.specificStep || IncomeAndAssetsSteps.IncomeSource;
    }
  }

  goToStep(event: any) {
    this.currentStep = event
  }

  goToSection(event: any) {
    this.sectionChange.emit(event);
  }
}
